<template>
  <section class="our_services_page">
    <div class="our_services_page_main">
      <router-link to="/" class="home_rdrtc_cross">
        <i aria-hidden="true" class="fa fa-times-circle-o mbl_cross"></i>
      </router-link>
      <div class="our_services_page_content">
        <h1 class="main_heading">Our Services</h1>
        <div class="main_subheading">
          <p>
            Lymphomap is an Artificial Intelligence and Machine Learning–powered
            online digital health ecosystem, built on the cloud to advance
            cancer and other serious illness research and treatment. Our mission
            is to harness the power of AI-driven precision medicine,
            collaborative tools, and global networking to accelerate
            breakthroughs in healthcare. Designed for clinicians, researchers,
            and medical professionals, Lymphomap offers an integrated suite of
            services that enable seamless collaboration, secure data management,
            and cutting-edge AI model development—all within one platform.
          </p>
          <p>
            From our Online Remote Workspace, which streamlines communication
            and project management, to AWERACK, our comprehensive research paper
            database, every service is crafted to empower the medical community
            with the right tools for discovery and innovation.
          </p>
          <p>
            Our AI & Data Lab stands at the heart of Lymphomap, enabling
            members to build advanced ML models for diagnosis, prognosis, and
            treatment planning. Complementing these features is our Professional
            Medical Network, connecting experts from diverse fields to foster
            meaningful collaborations and multidisciplinary research.
          </p>
          <p>
            Together, these services form a unified ecosystem where technology,
            knowledge, and community converge—driving progress toward more
            effective treatments, improved patient outcomes, and a future where
            innovation leads the fight against life-threatening diseases.
          </p>
          <p class="mb-0">
            Welcome to Lymphomap, an AI and ML powered digital health ecosystem.
          </p>
        </div>
        <div class="list_box_content">
          <div class="row">
            <div
              v-for="(service, index) in services"
              :key="index"
              class="col-sm-3"
            >
              <div class="content_box"
              :class="serviceInfo && serviceInfo.id == service.id ? 'active' : ''">
                <a href="javascript:void(0)" @click="selectService(service)">
                  <div class="box_thumb">
                    <img :src="service.image" class="img-fluid" :alt="service.title" />
                  </div>
                  <div class="tileinfo">
                    <h3 class="tile_name">{{ service.title }}</h3>
                    <div class="tile_desgination">
                      <p>{{ service.description }}</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="service_info_box" v-if="serviceInfo" ref="serviceInfoBox">
              <div class="info_content_box">
                <a href="#">
                  <div class="box_thumb">
                    <img :src="serviceInfo.image" class="img-fluid" :alt="serviceInfo.title" />
                  </div>
                  <div class="tileinfo">
                    <h3 class="tile_name">{{ serviceInfo.title }}</h3>
                    <div class="tile_desgination">
                      <p>{{ serviceInfo.description }}</p>
                    </div>
                  </div>
                </a>
              </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OurServices',
  data() {
    return {
      services: [
        { id:"1",
          title: 'AI & Data Lab – Precision Medicine Powered by AI',
          description:
            'The AI & Data Lab is the core of Lymphomap’s mission—where cutting-edge artificial intelligence meets medical innovation. Our integrated medical machine learning platform enables doctors and clinicians to build one-click AI solutions that address real-world healthcare challenges. At present, our ML models specialize in diagnosis and prognosis for various types of cancer, empowering clinicians with faster, data-driven insights. Members can securely upload datasets—with strict privacy controls ensuring no external access—to create and train their own ML models. For those on our Neural (Pro) package, our expert AI Engineering team provides tailored support in developing custom ML models that assist in patient outcome predictions, treatment planning, and disease management. Designed to advance precision medicine, the AI & Data Lab helps clinicians focus on targeted treatment protocols, potentially doubling survival rates and improving prognosis for remission. Flexible and collaborative, it supports a diverse range of research initiatives, fostering breakthroughs across the medical community.',
          image: require('@/assets/images/banner/ai_data.jpg'),
        },
        { id:"2",
          title: 'Online Remote Workspace',
          description:
            'Our online remote workspace is designed to bring teams, collaborators, and communities together—no matter where they are in the world. Equipped with secure video conferencing, group chats, file sharing, and an intuitive scheduler, it offers everything you need to stay connected and productive. Members can attend or host webinars, organize public meetings (even with non-members), and engage in real-time note collaboration, fostering a sense of connection and engagement. With 1 GB of personal storage under the convenient briefcase feature, you can safely store important files for quick access. Stay organized with a personal to-do list and never miss an important event with our integrated calendar that keeps all meetings and deadlines in view. Whether it’s for brainstorming, presenting, or simply keeping your projects on track, our workspace makes collaboration effortless.',
          image: require('@/assets/images/banner/remote_work.jpg'),
        },
        { id:"3",
          title: 'AWERACK – Research Paper Database',
          description:
            'AWERACK is our robust, centralized research paper database built to streamline how you store, organize, and discover knowledge. Whether you’re uploading your research, curating papers you’ve compiled, or creating a personalized digital shelf of references, AWERACK keeps your work structured and accessible. With our integrated web search tool, you can instantly explore research papers from across the internet, expanding your resources and deepening your insights. Collaboration is at the heart of AWERACK—add connected members on Lymphomap to co-create, review, and manage larger projects or assignments as a team. Dedicated to advancing cancer and medical research, AWERACK is designed to foster innovation and support the development of new treatment protocols, making it a cornerstone of the Lymphomap ecosystem.',
          image: require('@/assets/images/banner/research_apper.webp'),
        },
        { id:"4",
          title: 'Professional Network',
          description:
            'Lymphomap’s built-in Professional Network connects experts from across the healthcare and medical spectrum. Upon signing up for free, new members gain access to our Members section, where they can view and connect with other professionals on the platform. Our community spans a diverse range of specialties, including oncology, radiology, clinical medicine, medical physics, research, biochemistry, and more. Advanced filters make it easy to find the right collaborators based on professional category, fostering targeted connections that matter. Designed to encourage collaboration and knowledge exchange, this network serves as one of the core pillars of Lymphomap—because we believe that cross-disciplinary partnerships are essential for scientific breakthroughs and medical advancement.',
          image: require('@/assets/images/banner/network.jpg'),
        },
      ],
      serviceInfo:null
    };
  },
  mounted() {
    document.body.classList.add('dashboard');
  },
  methods:{
    scrollToServiceInfo() {
      // Use $nextTick to ensure the DOM is updated before scrolling
      this.$nextTick(() => {
        if (this.$refs.serviceInfoBox) {
          this.$refs.serviceInfoBox.scrollIntoView({ behavior: 'smooth' });
        }
      });
    },
    selectService(service) {
      this.serviceInfo = service;
      this.scrollToServiceInfo(); // Call the scroll method after setting the service info
    },
  },
  beforeUnmount() {
    document.body.classList.remove('dashboard');
  },
};
</script>

<style lang="scss" scoped>
.our_services_page {
    min-height: 100dvh;
    padding: 70px 10px 10px;

    .our_services_page_main {
        color: #ffffff;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
        letter-spacing: 1px;
        background: rgba(0, 0, 0, 0.75);
        min-height: calc(100dvh - 80px);
        position: relative;
    }

    .our_services_page_content {
        padding: 20px 30px;
        @media only screen and (max-width:767px) {
          padding: 25px 15px;
        }

        .main_heading {
            color: #d29e00;
            font-size: 40px;
            margin-bottom: 5px;
            font-family: 'origin_tech_demoregular';
            line-height: 1;

            @media only screen and (max-width:767px) {
                font-size: 32px;
            }
        }

        .main_subheading {
            background: rgba(228, 233, 237, .1);
            padding: 15px;
            margin: 20px 0px;
            border-radius: 4px;
           p{
                font-size: 1.1rem;
                color: #fff9db;
                margin-bottom: 10px;
                line-height: 1.4;
                text-align: justify;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;

                @media only screen and (max-width:767px) {
                    font-size: 13px;
                }
           }
        }

        .list_box_content {
            .row {
                margin: 0 -7px;

                .col-sm-3 {
                    padding: 7px;
                }
            }
        }

        .content_box {
            background: rgba(255, 255, 255, 0.1);
            padding: 10px;
            border-radius: 8px;
            text-align: left;
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            transform-origin: center center;
            -webkit-transform-origin: center center;
            -moz-transform-origin: center center;

            &:hover {
                transform: scale(1.05);
                -webkit-transform: scale(1.05);
                -moz-transform: scale(1.05);
                background: rgba(255, 243, 19, 0.2);

                .tile_name {
                    color: #ffd400 !important;
                }
            }
            &.active{
                background: rgba(255, 243, 19, 0.2);
            }

            a {
                color: inherit;
                text-decoration: none;
            }

            .box_thumb {
                height: 185px;
                overflow: hidden;

                .img-fluid {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: center center;
                }
            }

            .tileinfo {
                margin-top: 8px;

                .tile_name {
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 1.3;
                    margin: 0px 0px 5px;
                    font-family: 'BeonMedium';
                    height: 45px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                    line-clamp: 2;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    display: -webkit-box;
                    color: #87cefa;
                }

                .tile_desgination {
                    font-size: 16px;
                    color: #e7dac0;
                    line-height: 1.3;
                    margin-top: 15px;
                    height: 40px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                    line-clamp: 2;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    display: -webkit-box;
                    p{margin: 0px;}
                }
            }
        }
        .service_info_box {
            padding: 80px 0 0;
            .info_content_box {
                background: rgba(255, 255, 255, 0.1);
                padding: 10px;
                border-radius: 8px;
                text-align: left;

                a {
                    color: inherit;
                    text-decoration: none;
                }

                .box_thumb {
                    height: 380px;
                    overflow: hidden;
                    margin-bottom: 20px;
                    border: 2px solid #202020;
                    border-radius: 4px;

                    .img-fluid {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        object-position: center center;
                    }
                }

                .tileinfo {
                    margin-top: 8px;

                    .tile_name {
                        font-size: 26px;
                        font-weight: 600;
                        line-height: 1.3;
                        margin: 0px 0px 5px;
                        font-family: 'BeonMedium';
                        color: #87cefa;
                    }

                    .tile_desgination {
                        font-size: 18px;
                        color: #e7dac0;
                        line-height: 1.3;
                        margin-top: 10px;
                        p{margin: 0px;}
                    }
                }
            }
        }
    }

    .home_rdrtc_cross{
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        z-index: 100;
        padding: 4px 10px;
        color: #e4002b;
        font-size: 28px;
        background-color: rgba(31, 31, 31, 0.5);
        border-radius: 5px;
        line-height: 1;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border: 1px solid rgba(174, 182, 184, 0.1);
        overflow: hidden;
        display: inline-block;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(120deg,
                    transparent,
                    rgba(255, 255, 255, 0.2),
                    transparent);
            left: -100%;
            transition: all 0.65s ease-in-out;
        }

        &:hover {
            box-shadow: 1px 1px 25px 10px rgba(255, 255, 255, 0.5) !important;
            color:#ffd400;

            &::before {
                left: 100%;
            }
        }
    }

    .mobile_view_display {
        display: none !important;
    }

    @media only screen and (max-width:767px) {
        .mobile_view_display {
            display: block !important;
        }
    }
}
</style>